import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CursorHandIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="cursorHand" ref={ref} {...props}>
      <path d="M14.2,21.57H6.93c-1.47,0-2.2-1.87-2.9-3.67-.1-.26-.2-.52-.31-.77C3,15.39,2.27,12.91,2.24,12.8a1.27,1.27,0,0,1,0-.28,1.93,1.93,0,0,1,.66-1.22,2,2,0,0,1,1.52-.36A3.28,3.28,0,0,1,6.45,12.1V4.17A2.16,2.16,0,0,1,8.77,2.1,2.11,2.11,0,0,1,11,4.17v6.08c1.35.44,4.91,1.61,5.44,1.81,1.15.42,1.6,1.31,1.38,2.73-.17,1.16-.68,4.05-.86,5.07C16.85,20.64,16.26,21.57,14.2,21.57Zm-10.46-9c.18.61.8,2.6,1.37,4,.11.26.21.52.32.79.32.82,1.06,2.72,1.5,2.72H14.2c1.23,0,1.3-.36,1.32-.48.18-1,.69-3.88.86-5,.14-.9-.12-1-.42-1.1-.62-.23-5.85-2-5.9-2a.75.75,0,0,1-.52-.72V4.17c0-.55-.64-.57-.77-.57S8,3.6,8,4.17V14.84a.75.75,0,0,1-1.44.3c-.78-1.81-1.46-2.6-2.32-2.72C3.93,12.39,3.8,12.43,3.74,12.56Zm9.87-9a1,1,0,1,0,1,1A1,1,0,0,0,13.61,3.54Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,17.61,3.54Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,21.61,3.54Z" />
    </Icon>
  ),
) as IconWithRender;

CursorHandIcon.displayName = 'CursorHandIcon';
CursorHandIcon.renderIcon = (props) => <CursorHandIcon {...props} />;
export default CursorHandIcon;
